export interface IMultilingualState {
  lang: string;
}

export const initialState: IMultilingualState = {
  lang: 'en',
};
